export const QB_TAXCODES_MOCK = [
  { id: "TAX", ownerEmail: "", name: "TAX", rate: 0 },
  { id: "NON", ownerEmail: "", name: "NON", rate: 0 },
  { id: "CustomSalesTax", ownerEmail: "", name: "CustomSalesTax", rate: 0 },
  { id: "3", ownerEmail: "", name: "CA-San Francisco-San Francisco", rate: 0 },
  { id: "5", ownerEmail: "", name: "None", rate: 0 },
  { id: "2", ownerEmail: "", name: "Out of scope", rate: 0 },
  { id: "4", ownerEmail: "", name: "VAT", rate: 0 },
];
